<template>
  <el-dialog
    :visible="showofficeEditor"
    width="1250px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div slot="title" class="titleI">
      <p>无需添加变量信息，发起时可以直接编辑文件内容</p>
      <el-button size="small" class="edit-cancel-btn-sty" @click="CancelSave">取消保存</el-button>
      <el-tooltip effect="dark" content="完成编辑后，编辑过的内容将替换原文件中的内容。" placement="left">
        <el-button type="primary" size="small" class="edit-save-btn-sty" @click="finishEdit">完成编辑</el-button>
      </el-tooltip>
    </div>
    <div class="office-body">
      <only-office
        v-if="showofficeEditor"
        :editor="editor.editorConfig"
        class="office-box"
      ></only-office>
      <!-- <div class="r-info">
        <p style="font-weight: bold; margin-bottom: 10px">提示：</p>
        <p style="margin-bottom: 10px">
          编辑的内容会自动保存，也可通过点击左上角保存按钮主动保存；
        </p>
        <p>完成编辑后，编辑过的内容将替换原文件中的内容。</p>
        <div class="btn-box">
          <el-button type="primary" size="medium" @click="finishEdit"
            >完成编辑</el-button
          >
        </div>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>

import onlyOffice from "./index.vue";
export default {
  components: { onlyOffice },
  props: {
    showofficeEditor: Boolean,
    editor: {
      type: Object,
      default: () => {
        return {
          editorConfig: {},
          sourceFile: {},
          fileIndex
        };
      }
    }
  },
  data () {
    return {
    };
  },
  mounted () {
    console.log("editor", this.editor);
  },
  methods: {
    handleClose (done) {
      this.$emit("update:showofficeEditor", false);
    },
    finishEdit () {
      const { sourceFile, fileIndex } = this.editor;
      this.$emit("saveLoading", sourceFile, fileIndex);
      this.handleClose();
    },
    // 取消保存
    CancelSave(){
      const _this=this,{ sourceFile, fileIndex } = this.editor;;
      _this.$confirm('取消保存将不保留任何已经修改的内容，是否确定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$emit("editedFile", {cancel:1,...sourceFile}, fileIndex);
        _this.handleClose();
      }).catch(() => {});
    },
  }
};
</script>

<style scoped lang="less">
  /deep/ .el-dialog__body {
    height: 91vh !important;
    max-height: 91vh;
  }
.titleI{
  position: relative;
  > p {
    text-align: center;
  }
  .edit-save-btn-sty{
    position: absolute;
    top: 3px;
    right: 21px;
  }
  .edit-cancel-btn-sty{
    position: absolute;
    top: 3px;
    right: 120px;
  }
}
.office-body {
  display: flex;
  .r-info {
    padding: 10px;
  }
  .btn-box {
    margin-top: 20px;
    text-align: center;
  }
}
.office-box {
  width: 170vw;
  height: 83vh;
}
</style>



// WEBPACK FOOTER //
// components/onlyOffice/editorPup.vue